"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.headerScheme = exports.spacingScheme12 = exports.spacingScheme15 = exports.paperMixin = exports.effectMixins = exports.buttonDefaultScheme = void 0;
var system_1 = require("../system");
__exportStar(require("./typography"), exports);
var buttonDefaultScheme = function (colors) { return ({
    textColor: colors.system.TextMain,
}); };
exports.buttonDefaultScheme = buttonDefaultScheme;
var overlay = {
    position: 'absolute',
    display: 'block',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
};
var loadingEffect = function (effectsScheme) {
    return ({
        '@keyframes loading': {
            '0%': {
                transform: 'translateX(-100%)',
            },
            '100%': {
                transform: 'translateX(100%)',
            },
        },
        loadingEffect: {
            '&:after': __assign(__assign({}, overlay), { animation: '$loading 2s infinite', display: 'block', content: '""', width: '100%', height: '100%', background: effectsScheme.loadingGradient }),
        },
    });
};
var effectMixins = function (effectsScheme) {
    var _a;
    var loading = loadingEffect(effectsScheme);
    var buttonBefore = __assign(__assign({}, overlay), { pointerEvents: 'none', content: '""', backgroundColor: 'transparent', transition: 'background-color 0.2s ease-out', zIndex: 1 });
    return _a = {},
        _a[system_1.Effects.ShadowBottom] = {
            boxShadow: effectsScheme.bottomShadow,
        },
        _a[system_1.Effects.TooltipShadow] = {
            filter: "drop-shadow(".concat(effectsScheme.bottomShadow, ")"),
        },
        _a[system_1.Effects.ButtonLoading] = loading,
        _a[system_1.Effects.Hovered] = function (hoverPrefix) {
            var _a;
            if (hoverPrefix === void 0) { hoverPrefix = '&:hover'; }
            return (_a = {
                    '&': {
                        overflow: 'hidden',
                        position: 'relative',
                    },
                    '&::before': buttonBefore
                },
                _a["".concat(hoverPrefix, "::before")] = {
                    backgroundColor: "rgba(".concat(effectsScheme.overlayColor, ",0.04)"),
                },
                _a);
        },
        _a[system_1.Effects.Pressed] = function (hoverPrefix) {
            var _a;
            if (hoverPrefix === void 0) { hoverPrefix = '&:hover:active'; }
            return (_a = {
                    '&': {
                        overflow: 'hidden',
                        position: 'relative',
                    },
                    '&::before': buttonBefore,
                    '&:active::before': {
                        backgroundColor: "rgba(".concat(effectsScheme.overlayColor, ",0.1)"),
                    }
                },
                _a["".concat(hoverPrefix, "::before")] = {
                    backgroundColor: "rgba(".concat(effectsScheme.overlayColor, ",0.1)"),
                },
                _a);
        },
        _a;
};
exports.effectMixins = effectMixins;
function paperMixin(effects, typography, colors) {
    return __assign(__assign(__assign({}, effects.ShadowBottom), typography.Body), { backgroundColor: colors.system.BgMain, borderRadius: 16, boxSizing: 'border-box', '& *': {
            boxSizing: 'border-box',
        } });
}
exports.paperMixin = paperMixin;
exports.spacingScheme15 = {
    columns: 15,
    spaceUnit: system_1.Spacing.L,
    minContentWidth: 1280,
    maxContentWidth: 1440,
};
exports.spacingScheme12 = {
    columns: 12,
    spaceUnit: system_1.Spacing.L,
    minContentWidth: 1024,
    maxContentWidth: 1152,
};
exports.headerScheme = {
    height: 64,
};
